import { Controller } from "@hotwired/stimulus"

export default class extends Controller {

    connect() {
        document.addEventListener('turbo:before-stream-render', this.clearQuestion)
    }

    disconnect() {
        document.removeEventListener('turbo:before-stream-render', this.clearQuestion)
    }

    clearQuestion() {
        document.getElementById('question_name').value = '';
    }

    clearForm() {
        document.getElementById("new_question_form").reset();
    }
}
